package com.example.hukakmp.data

import com.example.hukakmp.model.PescadexSpeciesInfo

/**
 * Catálogo compartido generado desde el archivo peces_argentinos1.json
 * de Huka Android. Mantener esta lista sincronizada con el catálogo original.
 */
object PescadexCatalog {
    val species: List<PescadexSpeciesInfo> = listOf(
        PescadexSpeciesInfo(
            id = "anchoa_de_banco",
            nombreComun = "Anchoa de banco",
            nombreCientifico = "Engraulis anchoita",
            habitat = "Aguas costeras y plataforma continental",
            mejoresCarnadas = listOf("pequeños crustaceos", "plancton", "artificiales muy pequeños"),
            mejorHorario = "Mañana temprano",
            tecnica = "Pesca con redes o anzuelos muy pequeños",
            tamano = "5-15 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "bacalao_criollo",
            nombreComun = "Bacalao criollo",
            nombreCientifico = "Salilota australis",
            habitat = "Aguas profundas de la Patagonia",
            mejoresCarnadas = listOf("calamares", "peces pequeños", "carnada natural"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo en aguas profundas",
            tamano = "30-80 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "bacota",
            nombreComun = "Bacota",
            nombreCientifico = "Parapimelodus valenciennis",
            habitat = "Rios y arroyos de agua dulce",
            mejoresCarnadas = listOf("lombrices", "insectos", "carnada viva"),
            mejorHorario = "Noche",
            tecnica = "Pesca de fondo",
            tamano = "15-30 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "bagre_de_mar",
            nombreComun = "Bagre de mar",
            nombreCientifico = "Genidens barbus",
            habitat = "Aguas costeras y estuarios",
            mejoresCarnadas = listOf("camarones", "cangrejos", "lombrices marinas"),
            mejorHorario = "Tarde y noche",
            tecnica = "Pesca de fondo desde costa",
            tamano = "30-60 cm",
            temporada = "Verano y otoño",
        ),
        PescadexSpeciesInfo(
            id = "bagre_otuno",
            nombreComun = "Bagre otuno",
            nombreCientifico = "Genidens planifrons",
            habitat = "Estuarios y aguas salobres",
            mejoresCarnadas = listOf("camarones", "mejillones", "carnada natural"),
            mejorHorario = "Noche",
            tecnica = "Pesca de fondo",
            tamano = "25-50 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "bagre_del_torrente",
            nombreComun = "Bagre del torrente",
            nombreCientifico = "Heptapterus mustelinus",
            habitat = "Arroyos y rios de montaña",
            mejoresCarnadas = listOf("insectos", "lombrices pequeñas", "carnada viva"),
            mejorHorario = "Noche",
            tecnica = "Pesca liviana en correderas",
            tamano = "10-25 cm",
            temporada = "Primavera y verano",
        ),
        PescadexSpeciesInfo(
            id = "besugo",
            nombreComun = "Besugo",
            nombreCientifico = "Pagrus pagrus",
            habitat = "Fondos rocosos y arenosos del mar",
            mejoresCarnadas = listOf("camarones", "cangrejos", "pulpitos", "carnada natural"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Pesca de fondo embarcado",
            tamano = "30-80 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "bonito",
            nombreComun = "Bonito",
            nombreCientifico = "Sarda sarda",
            habitat = "Aguas abiertas del Atlantico",
            mejoresCarnadas = listOf("sardinas", "anchoitas", "señuelo plateados"),
            mejorHorario = "Mañana temprano",
            tecnica = "Trolling y spinning",
            tamano = "40-80 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "brotola",
            nombreComun = "Brotola",
            nombreCientifico = "Urophycis brasiliensis",
            habitat = "Fondos blandos de la plataforma continental",
            mejoresCarnadas = listOf("calamares", "camarones", "peces pequeños"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo embarcado",
            tamano = "30-70 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "burriqueta",
            nombreComun = "Burriqueta",
            nombreCientifico = "Menticirrhus americanus",
            habitat = "Aguas costeras sobre fondos arenosos",
            mejoresCarnadas = listOf("gusanos marinos", "camarones", "almejitas"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Surf casting",
            tamano = "20-40 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "caballa",
            nombreComun = "Caballa",
            nombreCientifico = "Scomber japonicus",
            habitat = "Aguas abiertas del Atlantico",
            mejoresCarnadas = listOf("pequeños peces", "señuelo plateados", "plumas"),
            mejorHorario = "Mañana",
            tecnica = "Trolling liviano y spinning",
            tamano = "25-40 cm",
            temporada = "Verano y otoño",
        ),
        PescadexSpeciesInfo(
            id = "carpa",
            nombreComun = "Carpa",
            nombreCientifico = "Cyprinus carpio",
            habitat = "Lagunas, embalses y rios de llanura",
            mejoresCarnadas = listOf("maiz", "pan", "pellets", "lombrices"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Pesca de fondo con boya",
            tamano = "30-80 cm",
            temporada = "Primavera y verano",
        ),
        PescadexSpeciesInfo(
            id = "castanieta",
            nombreComun = "Castanieta",
            nombreCientifico = "Cheilodactylus bergi",
            habitat = "Fondos rocosos costeros",
            mejoresCarnadas = listOf("mejillones", "cangrejos", "camarones"),
            mejorHorario = "Mañana",
            tecnica = "Pesca de fondo desde costa",
            tamano = "25-45 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "cazon",
            nombreComun = "Cazon",
            nombreCientifico = "Galeorhinus galeus",
            habitat = "Aguas costeras del Atlantico",
            mejoresCarnadas = listOf("cabezas de pescado", "filetes", "calamares grandes"),
            mejorHorario = "Noche",
            tecnica = "Pesca pesada de fondo",
            tamano = "80-150 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "chernia",
            nombreComun = "Chernia",
            nombreCientifico = "Epinephelus marginatus",
            habitat = "Fondos rocosos y arrecifes",
            mejoresCarnadas = listOf("peces vivos", "calamares", "cangrejos"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Pesca de fondo en estructuras",
            tamano = "50-120 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "chucho",
            nombreComun = "Chucho",
            nombreCientifico = "Myliobatis goodei",
            habitat = "Fondos arenosos costeros",
            mejoresCarnadas = listOf("almejas", "cangrejos", "camarones"),
            mejorHorario = "Tarde",
            tecnica = "Pesca de fondo desde costa",
            tamano = "80-150 cm de envergadura",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "cocherito",
            nombreComun = "Cocherito",
            nombreCientifico = "Callorhinchus callorynchus",
            habitat = "Fondos blandos de aguas frias",
            mejoresCarnadas = listOf("gusanos marinos", "camarones", "peces pequeños"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo embarcado",
            tamano = "60-120 cm",
            temporada = "Invierno",
        ),
        PescadexSpeciesInfo(
            id = "congrio",
            nombreComun = "Congrio",
            nombreCientifico = "Conger orbignyanus",
            habitat = "Fondos rocosos y grietas",
            mejoresCarnadas = listOf("pulpos", "calamares", "pescado fresco"),
            mejorHorario = "Noche",
            tecnica = "Pesca de fondo pesada",
            tamano = "100-200 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "cornalito",
            nombreComun = "Cornalito",
            nombreCientifico = "Sorgentinia incisa",
            habitat = "Aguas costeras del Atlantico Sur",
            mejoresCarnadas = listOf("plancton", "muy pequeños artificiales"),
            mejorHorario = "Mañana",
            tecnica = "Pesca con redes finas",
            tamano = "8-15 cm",
            temporada = "Primavera y verano",
        ),
        PescadexSpeciesInfo(
            id = "corvina_negra",
            nombreComun = "Corvina negra",
            nombreCientifico = "Pogonias cromis",
            habitat = "Aguas costeras y estuarios",
            mejoresCarnadas = listOf("cangrejos", "camarones", "almejas"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Surf casting y pesca embarcada",
            tamano = "40-100 cm",
            temporada = "Verano y otoño",
        ),
        PescadexSpeciesInfo(
            id = "corvina_rubia",
            nombreComun = "Corvina rubia",
            nombreCientifico = "Micropogonias furnieri",
            habitat = "Aguas costeras del Rio de la Plata",
            mejoresCarnadas = listOf("camarones", "lombriz de mar", "mejillones"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Surf casting",
            tamano = "30-80 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "diablito",
            nombreComun = "Diablito",
            nombreCientifico = "Scorpaena brasiliensis",
            habitat = "Fondos rocosos costeros",
            mejoresCarnadas = listOf("camarones", "peces pequeños", "cangrejos"),
            mejorHorario = "Noche",
            tecnica = "Pesca de fondo cuidadosa",
            tamano = "15-30 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "escalandrun",
            nombreComun = "Escalandrun",
            nombreCientifico = "Carcharhinus brachyurus",
            habitat = "Aguas costeras y oceanicas",
            mejoresCarnadas = listOf("peces grandes", "cabezas de pescado"),
            mejorHorario = "Amanecer y atardecer",
            tecnica = "Pesca pesada embarcada",
            tamano = "150-300 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "escrofalo",
            nombreComun = "Escrofalo",
            nombreCientifico = "Sebastes oculatus",
            habitat = "Aguas profundas patagonicas",
            mejoresCarnadas = listOf("calamares", "peces pequeños", "camarones"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo profunda",
            tamano = "30-60 cm",
            temporada = "Invierno",
        ),
        PescadexSpeciesInfo(
            id = "espinillo",
            nombreComun = "Espinillo",
            nombreCientifico = "Squalus acanthias",
            habitat = "Aguas frias de la Patagonia",
            mejoresCarnadas = listOf("peces pequeños", "calamares", "carnada fresca"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo embarcada",
            tamano = "60-120 cm",
            temporada = "Invierno",
        ),
        PescadexSpeciesInfo(
            id = "gallo",
            nombreComun = "Gallo",
            nombreCientifico = "Callorhinchus callorynchus",
            habitat = "Fondos blandos de aguas frias",
            mejoresCarnadas = listOf("gusanos", "moluscos", "crustaceos"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo",
            tamano = "80-120 cm",
            temporada = "Invierno",
        ),
        PescadexSpeciesInfo(
            id = "garopa",
            nombreComun = "Garopa",
            nombreCientifico = "Epinephelus marginatus",
            habitat = "Fondos rocosos y arrecifes artificiales",
            mejoresCarnadas = listOf("peces vivos", "calamares frescos", "cangrejos"),
            mejorHorario = "Mañana temprano",
            tecnica = "Pesca de fondo en estructuras",
            tamano = "40-100 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "gatopardo",
            nombreComun = "Gatopardo",
            nombreCientifico = "Notorynchus cepedianus",
            habitat = "Aguas costeras templadas",
            mejoresCarnadas = listOf("peces grandes", "rayas", "focas"),
            mejorHorario = "Noche",
            tecnica = "Pesca pesada especializada",
            tamano = "200-300 cm",
            temporada = "Otoño",
        ),
        PescadexSpeciesInfo(
            id = "gatuzo",
            nombreComun = "Gatuzo",
            nombreCientifico = "Mustelus schmitti",
            habitat = "Fondos arenosos costeros",
            mejoresCarnadas = listOf("cangrejos", "calamares", "pescado fresco"),
            mejorHorario = "Noche",
            tecnica = "Pesca de fondo desde costa",
            tamano = "80-150 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "guitarra",
            nombreComun = "Guitarra",
            nombreCientifico = "Rhinobatos percellens",
            habitat = "Fondos arenosos costeros",
            mejoresCarnadas = listOf("camarones", "cangrejos", "gusanos marinos"),
            mejorHorario = "Tarde y noche",
            tecnica = "Pesca de fondo desde costa",
            tamano = "60-120 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "guitarra_chica",
            nombreComun = "Guitarra chica",
            nombreCientifico = "Zapteryx brevirostris",
            habitat = "Aguas costeras poco profundas",
            mejoresCarnadas = listOf("camarones pequeños", "gusanos", "almejitas"),
            mejorHorario = "Tarde",
            tecnica = "Pesca liviana de fondo",
            tamano = "30-60 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "guitarra_grande",
            nombreComun = "Guitarra grande",
            nombreCientifico = "Rhinobatos horkelii",
            habitat = "Fondos arenosos profundos",
            mejoresCarnadas = listOf("cangrejos grandes", "calamares", "pescado"),
            mejorHorario = "Noche",
            tecnica = "Pesca pesada de fondo",
            tamano = "100-200 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "lenguado",
            nombreComun = "Lenguado",
            nombreCientifico = "Paralichthys orbignyanus",
            habitat = "Fondos arenosos y fangosos",
            mejoresCarnadas = listOf("lombrices marinas", "camarones", "pescaditos"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Pesca de fondo con deriva",
            tamano = "30-80 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "lisa",
            nombreComun = "Lisa",
            nombreCientifico = "Mugil liza",
            habitat = "Estuarios y aguas costeras",
            mejoresCarnadas = listOf("pan", "masa", "algas", "mejillones"),
            mejorHorario = "Mañana",
            tecnica = "Pesca con boya liviana",
            tamano = "30-60 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "mero",
            nombreComun = "Mero",
            nombreCientifico = "Acanthistius brasilianus",
            habitat = "Fondos rocosos y arrecifes",
            mejoresCarnadas = listOf("peces vivos", "calamares", "cangrejos grandes"),
            mejorHorario = "Mañana y atardecer",
            tecnica = "Pesca pesada de fondo",
            tamano = "50-150 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "palometa_pintada",
            nombreComun = "Palometa pintada",
            nombreCientifico = "Parona signata",
            habitat = "Aguas costeras y oceanicas",
            mejoresCarnadas = listOf("sardinas", "anchoitas", "señuelo plateados"),
            mejorHorario = "Mañana",
            tecnica = "Spinning y trolling liviano",
            tamano = "30-50 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "pampanito",
            nombreComun = "Pampanito",
            nombreCientifico = "Trachinotus marginatus",
            habitat = "Aguas costeras sobre fondos arenosos",
            mejoresCarnadas = listOf("camarones", "lombrices marinas", "artificiales"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Surf casting y spinning",
            tamano = "20-40 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "pargo",
            nombreComun = "Pargo",
            nombreCientifico = "Pagrus pagrus",
            habitat = "Fondos duros y rocosos",
            mejoresCarnadas = listOf("camarones", "cangrejos", "calamares"),
            mejorHorario = "Mañana",
            tecnica = "Pesca de fondo embarcada",
            tamano = "30-70 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "pejerrey_de_agua_dulce",
            nombreComun = "Pejerrey de agua dulce",
            nombreCientifico = "Odontesthes bonariensis",
            habitat = "Lagunas pampeanas y embalses",
            mejoresCarnadas = listOf("lombriz", "cascarudos", "artificiales pequeños"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca con boya y spinning liviano",
            tamano = "20-50 cm",
            temporada = "Marzo a noviembre",
        ),
        PescadexSpeciesInfo(
            id = "pejerrey",
            nombreComun = "Pejerrey",
            nombreCientifico = "Odontesthes bonariensis",
            habitat = "Lagunas pampeanas y embalses",
            mejoresCarnadas = listOf("lombriz", "cascarudos", "artificiales pequeños"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca con boya y spinning liviano",
            tamano = "20-50 cm",
            temporada = "Marzo a noviembre",
        ),
        PescadexSpeciesInfo(
            id = "pejerrey_de_agua_salada",
            nombreComun = "Pejerrey de agua salada",
            nombreCientifico = "Odontesthes argentinensis",
            habitat = "Aguas costeras del Atlantico",
            mejoresCarnadas = listOf("lombrices marinas", "camarones", "artificiales"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Surf casting liviano",
            tamano = "25-45 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "pejerrey_de_tosca",
            nombreComun = "Pejerrey de tosca",
            nombreCientifico = "Odontesthes bonariensis",
            habitat = "Canteras y lagunas artificiales",
            mejoresCarnadas = listOf("lombriz", "cascarudos", "masa"),
            mejorHorario = "Mañana temprano",
            tecnica = "Pesca con boya",
            tamano = "15-30 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "pejerrey_escardon",
            nombreComun = "Pejerrey Escardon",
            nombreCientifico = "Odontesthes perugiae",
            habitat = "Rios y arroyos de la Patagonia",
            mejoresCarnadas = listOf("insectos", "lombrices pequeñas", "artificiales"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Pesca con mosca y spinning ultraliviano",
            tamano = "15-25 cm",
            temporada = "Primavera y verano",
        ),
        PescadexSpeciesInfo(
            id = "pejerrey_manila",
            nombreComun = "Pejerrey Manila",
            nombreCientifico = "Odontesthes bonariensis",
            habitat = "Lagunas de agua dulce",
            mejoresCarnadas = listOf("lombriz", "cascarudos", "artificiales micro"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca con boya muy liviana",
            tamano = "12-20 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "pejerrey_sapito",
            nombreComun = "Pejerrey Sapito",
            nombreCientifico = "Jenynsia multidentata",
            habitat = "Arroyos y lagunas pequeñas",
            mejoresCarnadas = listOf("insectos muy pequeños", "micro artificiales"),
            mejorHorario = "Tarde",
            tecnica = "Pesca ultraliviana",
            tamano = "5-10 cm",
            temporada = "Primavera y verano",
        ),
        PescadexSpeciesInfo(
            id = "pejerrey_patagonico",
            nombreComun = "Pejerrey patagonico",
            nombreCientifico = "Odontesthes hatcheri",
            habitat = "Lagos y rios patagonicos",
            mejoresCarnadas = listOf("insectos", "lombrices", "artificiales"),
            mejorHorario = "Mañana y atardecer",
            tecnica = "Spinning liviano y mosca",
            tamano = "25-40 cm",
            temporada = "Noviembre a abril",
        ),
        PescadexSpeciesInfo(
            id = "perca",
            nombreComun = "Perca",
            nombreCientifico = "Percichthys trucha",
            habitat = "Lagos y rios patagonicos",
            mejoresCarnadas = listOf("lombrices", "insectos", "pequeños peces"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Spinning y pesca con boya",
            tamano = "20-40 cm",
            temporada = "Primavera y verano",
        ),
        PescadexSpeciesInfo(
            id = "pescadilla",
            nombreComun = "Pescadilla",
            nombreCientifico = "Cynoscion guatucupa",
            habitat = "Aguas costeras del Atlantico",
            mejoresCarnadas = listOf("lombrices marinas", "camarones", "pescaditos"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Surf casting",
            tamano = "30-60 cm",
            temporada = "Verano y otoño",
        ),
        PescadexSpeciesInfo(
            id = "pescadilla_real",
            nombreComun = "Pescadilla real",
            nombreCientifico = "Macrodon atricauda",
            habitat = "Aguas profundas de la plataforma continental",
            mejoresCarnadas = listOf("calamares", "pescados", "camarones grandes"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo embarcada",
            tamano = "40-80 cm",
            temporada = "Invierno",
        ),
        PescadexSpeciesInfo(
            id = "pez_angel",
            nombreComun = "Pez angel",
            nombreCientifico = "Pomacanthus paru",
            habitat = "Arrecifes y fondos rocosos tropicales",
            mejoresCarnadas = listOf("esponjas", "algas", "crustaceos pequeños"),
            mejorHorario = "Mañana",
            tecnica = "Pesca liviana de fondo",
            tamano = "20-40 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "pez_limon",
            nombreComun = "Pez limon",
            nombreCientifico = "Seriola lalandi",
            habitat = "Aguas oceanicas templadas",
            mejoresCarnadas = listOf("peces vivos", "calamares", "señuelo grandes"),
            mejorHorario = "Mañana",
            tecnica = "Trolling pesado",
            tamano = "60-150 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "pez_palo",
            nombreComun = "Pez palo",
            nombreCientifico = "Percophis brasiliensis",
            habitat = "Fondos arenosos de la plataforma",
            mejoresCarnadas = listOf("lombrices marinas", "calamares", "pescaditos"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo embarcada",
            tamano = "40-100 cm",
            temporada = "Invierno",
        ),
        PescadexSpeciesInfo(
            id = "pez_sable",
            nombreComun = "Pez sable",
            nombreCientifico = "Trichiurus lepturus",
            habitat = "Aguas costeras y oceanicas",
            mejoresCarnadas = listOf("peces pequeños", "calamares", "artificiales plateados"),
            mejorHorario = "Noche",
            tecnica = "Pesca de media agua",
            tamano = "80-150 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "pez_sapo",
            nombreComun = "Pez sapo",
            nombreCientifico = "Porichthys porosissimus",
            habitat = "Fondos rocosos y entre algas",
            mejoresCarnadas = listOf("camarones", "gusanos", "pescaditos"),
            mejorHorario = "Noche",
            tecnica = "Pesca de fondo cuidadosa",
            tamano = "15-30 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "pintarroja",
            nombreComun = "Pintarroja",
            nombreCientifico = "Schroederichthys bivius",
            habitat = "Fondos rocosos y de algas",
            mejoresCarnadas = listOf("peces pequeños", "calamares", "cangrejos"),
            mejorHorario = "Noche",
            tecnica = "Pesca de fondo",
            tamano = "50-80 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "raya",
            nombreComun = "Raya",
            nombreCientifico = "Raja flavirostris",
            habitat = "Fondos arenosos y fangosos",
            mejoresCarnadas = listOf("camarones", "cangrejos", "almejas", "gusanos marinos"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo pesada",
            tamano = "50-120 cm de envergadura",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "raya_a_lunares",
            nombreComun = "Raya a lunares",
            nombreCientifico = "Atlantoraja platana",
            habitat = "Fondos arenosos costeros",
            mejoresCarnadas = listOf("cangrejos", "camarones", "pescaditos"),
            mejorHorario = "Tarde y noche",
            tecnica = "Pesca de fondo desde costa",
            tamano = "60-100 cm de envergadura",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "raya_marmorada",
            nombreComun = "Raya marmorada",
            nombreCientifico = "Zearaja chilensis",
            habitat = "Fondos rocosos y mixtos",
            mejoresCarnadas = listOf("pulpitos", "calamares", "cangrejos"),
            mejorHorario = "Noche",
            tecnica = "Pesca de fondo embarcada",
            tamano = "80-150 cm de envergadura",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "raya_picuda",
            nombreComun = "Raya picuda",
            nombreCientifico = "Dipturus trachyderma",
            habitat = "Aguas profundas patagonicas",
            mejoresCarnadas = listOf("calamares grandes", "peces", "crustaceos"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo profunda",
            tamano = "100-200 cm de envergadura",
            temporada = "Invierno",
        ),
        PescadexSpeciesInfo(
            id = "robalo",
            nombreComun = "Robalo",
            nombreCientifico = "Eleginops maclovinus",
            habitat = "Aguas costeras patagonicas y canales",
            mejoresCarnadas = listOf("peces pequeños", "camarones", "señuelo"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Spinning y pesca con carnada viva",
            tamano = "40-90 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "salmon_chinook",
            nombreComun = "Salmon Chinook",
            nombreCientifico = "Oncorhynchus tshawytscha",
            habitat = "Lagos y rios patagonicos (introducido)",
            mejoresCarnadas = listOf("señuelo grandes", "cucharas", "carnada viva"),
            mejorHorario = "Mañana temprano y atardecer",
            tecnica = "Trolling y spinning pesado",
            tamano = "60-120 cm",
            temporada = "Noviembre a abril",
        ),
        PescadexSpeciesInfo(
            id = "salmon",
            nombreComun = "Salmon",
            nombreCientifico = "Oncorhynchus tshawytscha",
            habitat = "Lagos y rios patagonicos (introducido)",
            mejoresCarnadas = listOf("señuelo grandes", "cucharas", "carnada viva"),
            mejorHorario = "Mañana temprano y atardecer",
            tecnica = "Trolling y spinning pesado",
            tamano = "60-120 cm",
            temporada = "Noviembre a abril",
        ),
        PescadexSpeciesInfo(
            id = "salmon_coho",
            nombreComun = "Salmon Coho",
            nombreCientifico = "Oncorhynchus kisutch",
            habitat = "Lagos patagonicos (introducido)",
            mejoresCarnadas = listOf("señuelo plateados", "cucharas", "mosca"),
            mejorHorario = "Mañana y atardecer",
            tecnica = "Trolling liviano y fly fishing",
            tamano = "40-80 cm",
            temporada = "Diciembre a marzo",
        ),
        PescadexSpeciesInfo(
            id = "salmon_de_mar",
            nombreComun = "Salmon de mar",
            nombreCientifico = "Pseudopercis semifasciata",
            habitat = "Fondos arenosos de la plataforma continental",
            mejoresCarnadas = listOf("calamares", "lombrices marinas", "pescaditos"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo embarcada",
            tamano = "40-80 cm",
            temporada = "Invierno",
        ),
        PescadexSpeciesInfo(
            id = "salmon_del_atlantico",
            nombreComun = "Salmon del Atlantico",
            nombreCientifico = "Salmo salar",
            habitat = "Mar abierto y cultivos (introducido)",
            mejoresCarnadas = listOf("señuelo grandes", "peces", "camarones"),
            mejorHorario = "Mañana",
            tecnica = "Trolling oceanico",
            tamano = "60-120 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "saraca",
            nombreComun = "Saraca",
            nombreCientifico = "Brevoortia aurea",
            habitat = "Aguas costeras y estuarios",
            mejoresCarnadas = listOf("plancton", "masa", "pan"),
            mejorHorario = "Mañana",
            tecnica = "Pesca con redes o anzuelos pequeños",
            tamano = "20-35 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "sargo",
            nombreComun = "Sargo",
            nombreCientifico = "Diplodus argenteus",
            habitat = "Fondos rocosos y arrecifes costeros",
            mejoresCarnadas = listOf("mejillones", "cangrejos", "algas"),
            mejorHorario = "Mañana",
            tecnica = "Pesca de fondo desde costa",
            tamano = "20-40 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "savorin",
            nombreComun = "Savorin",
            nombreCientifico = "Seriolella porosa",
            habitat = "Aguas oceanicas templadas",
            mejoresCarnadas = listOf("peces pequeños", "calamares", "señuelo"),
            mejorHorario = "Mañana",
            tecnica = "Trolling y spinning",
            tamano = "30-60 cm",
            temporada = "Otoño e invierno",
        ),
        PescadexSpeciesInfo(
            id = "tiburon",
            nombreComun = "Tiburon",
            nombreCientifico = "Carcharodon carcharias",
            habitat = "Aguas oceanicas profundas",
            mejoresCarnadas = listOf("mamiferos marinos", "peces grandes", "señuelo gigantes"),
            mejorHorario = "Amanecer y atardecer",
            tecnica = "Pesca pesada especializada",
            tamano = "200-600 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "trucha",
            nombreComun = "Trucha",
            nombreCientifico = "Salmo trutta",
            habitat = "Rios y lagos patagonicos (introducida)",
            mejoresCarnadas = listOf("lombrices", "insectos", "señuelo", "mosca"),
            mejorHorario = "Mañana temprano y atardecer",
            tecnica = "Fly fishing, spinning, pesca con carnada",
            tamano = "30-80 cm",
            temporada = "Noviembre a abril",
        ),
        PescadexSpeciesInfo(
            id = "trucha_arcoiris",
            nombreComun = "Trucha arcoiris",
            nombreCientifico = "Oncorhynchus mykiss",
            habitat = "Lagos y rios patagonicos (introducida)",
            mejoresCarnadas = listOf("lombrices", "insectos", "cucharitas", "mosca"),
            mejorHorario = "Mañana y atardecer",
            tecnica = "Fly fishing y spinning",
            tamano = "25-70 cm",
            temporada = "Noviembre a abril",
        ),
        PescadexSpeciesInfo(
            id = "trucha_de_arroyo",
            nombreComun = "Trucha de arroyo",
            nombreCientifico = "Salvelinus fontinalis",
            habitat = "Arroyos y lagos frios patagonicos (introducida)",
            mejoresCarnadas = listOf("insectos", "lombrices pequeñas", "mosca seca"),
            mejorHorario = "Mañana temprano",
            tecnica = "Fly fishing ultraliviano",
            tamano = "20-50 cm",
            temporada = "Diciembre a marzo",
        ),
        PescadexSpeciesInfo(
            id = "trucha_de_lago",
            nombreComun = "Trucha de lago",
            nombreCientifico = "Salvelinus namaycush",
            habitat = "Lagos profundos patagonicos (introducida)",
            mejoresCarnadas = listOf("peces pequeños", "cucharas profundas", "señuelo"),
            mejorHorario = "Todo el dia",
            tecnica = "Trolling profundo",
            tamano = "40-100 cm",
            temporada = "Diciembre a abril",
        ),
        PescadexSpeciesInfo(
            id = "trucha_marron",
            nombreComun = "Trucha marron",
            nombreCientifico = "Salmo trutta",
            habitat = "Rios y lagos patagonicos (introducida)",
            mejoresCarnadas = listOf("lombrices", "insectos grandes", "señuelo oscuros"),
            mejorHorario = "Atardecer y noche",
            tecnica = "Pesca nocturna con carnada y spinning",
            tamano = "35-90 cm",
            temporada = "Noviembre a abril",
        ),
        PescadexSpeciesInfo(
            id = "turco",
            nombreComun = "Turco",
            nombreCientifico = "Labrisomus nuchipinnis",
            habitat = "Fondos rocosos y entre algas",
            mejoresCarnadas = listOf("pequeños crustaceos", "gusanos", "algas"),
            mejorHorario = "Mañana",
            tecnica = "Pesca liviana de fondo",
            tamano = "10-25 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "vieja_de_mar",
            nombreComun = "Vieja de mar",
            nombreCientifico = "Acanthistius patachonicus",
            habitat = "Fondos rocosos patagonicos",
            mejoresCarnadas = listOf("cangrejos", "pulpitos", "camarones"),
            mejorHorario = "Mañana y tarde",
            tecnica = "Pesca de fondo en estructuras",
            tamano = "30-70 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "dorado",
            nombreComun = "Dorado",
            nombreCientifico = "Salminus brasiliensis",
            habitat = "Rios de corriente fuerte, correderas y remansos",
            mejoresCarnadas = listOf("morena", "anguila", "sabalo", "señuelo", "mosca"),
            mejorHorario = "Mañana temprano y atardecer",
            tecnica = "Spinning, baitcasting, fly cast, carnada viva al garete",
            tamano = "50-100 cm",
            temporada = "Primavera y verano",
        ),
        PescadexSpeciesInfo(
            id = "surubi_pintado",
            nombreComun = "Surubi pintado",
            nombreCientifico = "Pseudoplatystoma corruscans",
            habitat = "Pozones profundos y cauces principales de rios",
            mejoresCarnadas = listOf("morena", "anguila", "cascarudo", "señuelo de profundidad"),
            mejorHorario = "Noche y madrugada",
            tecnica = "Pesca de fondo, trolling, al garete",
            tamano = "80-150 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "surubi_atigrado",
            nombreComun = "Surubi atigrado",
            nombreCientifico = "Pseudoplatystoma reticulatum",
            habitat = "Pozones y cauces principales",
            mejoresCarnadas = listOf("morena", "anguila", "cascarudo", "señuelo de profundidad"),
            mejorHorario = "Noche y madrugada",
            tecnica = "Pesca de fondo, trolling, al garete",
            tamano = "70-130 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "pacu",
            nombreComun = "Pacu",
            nombreCientifico = "Piaractus mesopotamicus",
            habitat = "Remansos, zonas con vegetacion y arboles frutales en las costas",
            mejoresCarnadas = listOf("frutas", "bolitas de masa", "maiz", "caracoles"),
            mejorHorario = "Horas de mas calor, mediodia y tarde",
            tecnica = "Pesca al golpe, baitcasting, boya",
            tamano = "40-70 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "boga",
            nombreComun = "Boga",
            nombreCientifico = "Megaleporinus obtusidens",
            habitat = "Rios caudalosos, cerca de piedras y estructuras",
            mejoresCarnadas = listOf("maiz", "masa", "salamin", "corazon", "caracol"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo con plomada corrediza, boya",
            tamano = "40-80 cm",
            temporada = "Primavera y verano",
        ),
        PescadexSpeciesInfo(
            id = "tararira",
            nombreComun = "Tararira",
            nombreCientifico = "Hoplias malabaricus",
            habitat = "Lagunas someras, arroyos y zonas con mucha vegetacion",
            mejoresCarnadas = listOf("señuelo de superficie", "ranas", "filet de pejerrey", "mosca"),
            mejorHorario = "Atardecer y noche",
            tecnica = "Baitcasting, spinning, fly cast, carnada viva",
            tamano = "30-60 cm",
            temporada = "Primavera y verano",
        ),
        PescadexSpeciesInfo(
            id = "tararira_tornasol",
            nombreComun = "Tararira Tornasol",
            nombreCientifico = "Hoplias lacerdae",
            habitat = "Rios y arroyos del litoral, zonas de corriente",
            mejoresCarnadas = listOf("señuelo", "carnada viva"),
            mejorHorario = "Atardecer",
            tecnica = "Baitcasting, spinning",
            tamano = "40-80 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "sabalo",
            nombreComun = "Sabalo",
            nombreCientifico = "Prochilodus lineatus",
            habitat = "Rios y lagunas, fondos fangosos",
            mejoresCarnadas = listOf("masa muy blanda"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo",
            tamano = "40-70 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "bagre_amarillo",
            nombreComun = "Bagre amarillo",
            nombreCientifico = "Pimelodus maculatus",
            habitat = "Rios, arroyos y lagunas",
            mejoresCarnadas = listOf("lombriz", "filet", "tripa de pollo"),
            mejorHorario = "Noche y atardecer",
            tecnica = "Pesca de fondo liviana",
            tamano = "20-40 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "bagre_sapo",
            nombreComun = "Bagre sapo",
            nombreCientifico = "Rhamdia quelen",
            habitat = "Arroyos, lagunas y fondos de barro",
            mejoresCarnadas = listOf("lombriz", "carne", "pasta"),
            mejorHorario = "Noche",
            tecnica = "Pesca de fondo",
            tamano = "20-35 cm",
            temporada = "Todo el año",
        ),
        PescadexSpeciesInfo(
            id = "armado",
            nombreComun = "Armado",
            nombreCientifico = "Pterodoras granulosus",
            habitat = "Cauces principales y fondos profundos",
            mejoresCarnadas = listOf("lombriz", "corazon", "masa", "tripa"),
            mejorHorario = "Noche",
            tecnica = "Pesca pesada de fondo",
            tamano = "40-70 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "manduvi",
            nombreComun = "Manduvi",
            nombreCientifico = "Ageneiosus valenciennesi",
            habitat = "Aguas abiertas y zonas de corriente moderada",
            mejoresCarnadas = listOf("mojarra viva", "filet", "morenita"),
            mejorHorario = "Noche y madrugada",
            tecnica = "Pesca a media agua, al garete",
            tamano = "30-50 cm",
            temporada = "Primavera y verano",
        ),
        PescadexSpeciesInfo(
            id = "chafalote",
            nombreComun = "Chafalote",
            nombreCientifico = "Raphiodon vulpinus",
            habitat = "Aguas rapidas y correderas",
            mejoresCarnadas = listOf("mojarra", "señuelo plateados", "cucharas"),
            mejorHorario = "Mañana y atardecer",
            tecnica = "Spinning, baitcasting, pesca al vuelo",
            tamano = "40-80 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "manguruyu",
            nombreComun = "Manguruyu",
            nombreCientifico = "Zungaro zungaro",
            habitat = "Pozones muy profundos del rio Parana y Uruguay",
            mejoresCarnadas = listOf("morena", "anguila grande", "sabalito"),
            mejorHorario = "Noche",
            tecnica = "Pesca muy pesada de fondo",
            tamano = "100-170 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "pira_pyta",
            nombreComun = "Pira Pyta",
            nombreCientifico = "Brycon orbignyanus",
            habitat = "Zonas de correderas, bajo arboles frutales",
            mejoresCarnadas = listOf("frutas", "insectos", "señuelo chicos", "mosca"),
            mejorHorario = "Mediodia y atardecer",
            tecnica = "Baitcasting, fly cast, boya",
            tamano = "30-60 cm",
            temporada = "Verano",
        ),
        PescadexSpeciesInfo(
            id = "palometa_de_rio",
            nombreComun = "Palometa de rio",
            nombreCientifico = "Serrasalmus maculatus",
            habitat = "Aguas calmas, lagunas y remansos",
            mejoresCarnadas = listOf("carne vacuna", "filet de pez", "corazon"),
            mejorHorario = "Todo el dia",
            tecnica = "Pesca de fondo o con boya con leader de acero",
            tamano = "15-30 cm",
            temporada = "Verano",
        ),
    )

    val byId: Map<String, PescadexSpeciesInfo> = species.associateBy { it.id }

    fun normalizeSpeciesId(name: String): String =
        name.lowercase()
            .replace("á", "a").replace("é", "e").replace("í", "i")
            .replace("ó", "o").replace("ú", "u").replace("ñ", "n")
            .replace(Regex("[^a-z0-9]+"), "_")
            .trim('_')

    fun findExact(name: String): PescadexSpeciesInfo? {
        val normalized = normalizeSpeciesId(name)
        if (normalized.isBlank()) return null

        return species.firstOrNull { speciesInfo ->
            speciesInfo.id == normalized ||
                normalizeSpeciesId(speciesInfo.nombreComun) == normalized
        }
    }

    fun isKnownSpecies(name: String): Boolean = findExact(name) != null

    fun canonicalName(name: String): String? = findExact(name)?.nombreComun

    fun findId(name: String): String? {
        val normalized = normalizeSpeciesId(name)
        if (normalized.isBlank()) return null
        if (byId.containsKey(normalized)) return normalized

        return byId.keys.firstOrNull { id ->
            normalized.contains(id) || id.contains(normalized)
        }
    }
}
